var _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEmailIcon = function SvgEmailIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "14px",
    viewBox: "0 0 18 14",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDF08-Style-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-463.000000, -123.000000)",
    fill: "#0B0E12",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Colors-Copy",
    transform: "translate(22.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M458.382586,105.367896 C458.493187,105.269896 458.649563,105.24751 458.782488,105.311677 C458.915027,105.375115 459,105.512964 459,105.664484 L459,105.664484 L459,115.444432 C459,116.30237 458.327285,117 457.500023,117 L457.500023,117 L442.500012,117 C441.672715,117 441,116.30237 441,115.444432 L441,115.444432 L441,105.664484 C441,105.512964 441.084973,105.375479 441.217512,105.311641 C441.349348,105.24824 441.506074,105.269859 441.617414,105.367859 C443.853844,107.333583 447.780375,110.795229 448.952977,111.890875 C449.571867,112.469651 450.428801,112.469651 451.04625,111.891641 C452.146359,110.863625 455.64293,107.776406 458.382586,105.367896 Z M457.499988,103 C457.959973,103 458.38916,103.218385 458.67702,103.599266 C458.801543,103.764094 458.778094,104.001073 458.624285,104.135896 C456.15382,106.305568 451.818984,110.123047 450.543832,111.314396 C450.373184,111.474266 450.190055,111.555167 450,111.555167 C449.809559,111.555167 449.626113,111.4735 449.455078,111.312865 C448.181016,110.122682 443.84618,106.305568 441.37575,104.135896 C441.221941,104.001073 441.198492,103.764094 441.323016,103.599302 C441.61084,103.218385 442.040063,103 442.500012,103 L442.500012,103 Z",
    id: "ic_envelope"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmailIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/email-icon.1de5d5f9.svg";
export { ForwardRef as ReactComponent };